export default class ServicesHelper {
    // Static method to fetch and validate JSON
    static async fetchAndValidateJSON(url: string): Promise<any> {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
        }
        const contentType = response.headers.get('Content-Type');
        if (!contentType || !contentType.includes('json')) {
            throw new Error(`The fetched file at ${url} is not a JSON file.`);
        }
        return response.json();
    }
}